export default "__VITE_ASSET__Bh2l1F4M__"